import React, { FC } from 'react'
import { ConfirmationModal, IConfirmationModalProps } from 'transfix-ui'
import { useAs2Certificate } from '../hooks/useAs2Certificate'

interface IActivateAs2CertificateConfirmationModalProps
  extends Pick<IConfirmationModalProps, 'onClose' | 'open'> {
  /**
   * @example '13'
   */
  as2CertificateId: string
  onClose: () => void
  open: boolean
  onDisplayUserFeedback: (message: string, level: 'error' | 'info') => void
  onSuccess: () => void
}

export const ActivateAs2CertificateConfirmationModal: FC<IActivateAs2CertificateConfirmationModalProps> = ({
  as2CertificateId,
  onClose,
  onDisplayUserFeedback,
  onSuccess,
  open,
}) => {
  const { activateAs2Certificate } = useAs2Certificate({
    displayUserFeedback: onDisplayUserFeedback,
  })

  const submitHandler = () => {
    activateAs2Certificate({
      id: as2CertificateId,
    })

    onClose()
    onSuccess()
  }

  return (
    <ConfirmationModal
      title='Activate AS2 Certificate?'
      size={4}
      open={open}
      actions={[
        { label: 'Cancel', type: 'dismiss' },
        {
          label: 'Activate',
          type: 'confirm',
          action: submitHandler,
        },
      ]}
      onClose={onClose}>
      <p>Activating this certificate will deactivate all other certificates for this connection.</p>
    </ConfirmationModal>
  )
}
